import React, { useEffect, useMemo } from 'react';
import { Form } from 'antd';
import { toCurrency, } from 'utils/utils';
import { shouldUpdateCompare } from 'utils/utils2';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  CiPrefinInterest,
  getPrefinInterestByCiid,
} from 'services/clientInvoice';
import Title from 'components/Title';
import { useForm } from 'antd/lib/form/Form';
import { useQuery } from 'react-query';
import ModalControllerNV from 'components/ModalControllerNV';

import PrefinInterestListModal from './ciPrefinInterestDetailListModal';

type TabClientInvoicePrefinInterestProps = {
  ciid: number | undefined;
  currcode:string;
  type?: string;
};

const TabClientInvoicePrefinInterest = (props: TabClientInvoicePrefinInterestProps) => {
  const { ciid, currcode,type } = props;
  const fieldName = 'ciprefininterest';
  const [form] = useForm();
  const { data: prefinInterest } = useQuery(
    ['getPrefinInterestByCiid', ciid],
    () =>
    getPrefinInterestByCiid({ ciid: Number(ciid) }).then((res) => {
        return res.list.filter((e) => e.calculatedamount > 0) || [];
      }),
    { enabled: !!ciid }
  );
  useEffect(() => {
    if (prefinInterest) {
      form.setFieldsValue({
        [fieldName]: prefinInterest,
      });
    }
  }, [form, prefinInterest]);

  const columns = useMemo<DataGridColDef<CiPrefinInterest>[]>(
    () => [
      {
        dataIndex: 'ctreference',
        width: '100px',
      },
      {
        dataIndex: 'ctedescription',
        width: '150px',
      },
      {
        dataIndex: 'prefinmethod',
        width: '100px',
      },
      {
        dataIndex: 'prefinperiodicity',
        width: '100px',
      },
      {
        dataIndex: 'calcdate',
        width: '100px',
        render: (value, record, index) => {
          return (
            <ModalControllerNV
              modal={({ setVisible, visible }) => (
                <PrefinInterestListModal
                  visible={visible}
                  list={record.ciPrefinInterestDetailList}
                  onCancel={() => setVisible(false)}
                  currcode={currcode}
                />
              )}
              content={({ setVisible, visible }) => (
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {value}
                </a>
              )}
            />
          );
        },
      },
      {
        dataIndex: 'duedate',
        width: '100px',
        render: (value, record, index) => {
          return (
            <ModalControllerNV
              modal={({ setVisible, visible }) => (
                <PrefinInterestListModal
                  visible={visible}
                  list={record.ciPrefinInterestDetailList}
                  onCancel={() => setVisible(false)}
                  currcode={currcode}
                />
              )}
              content={({ setVisible, visible }) => (
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {value}
                </a>
              )}
            />
          );
        },
      },
      {
        dataIndex: 'calculatedamount',
        width: '100px',
        render: (val, record) => toCurrency(val, currcode),
      },
      {
        dataIndex: 'invoicedamount',
        width: '100px',
        render: (val, record) => toCurrency(val, currcode),
      },
    
    ],

    []
  );

  return (
    <div style={{ backgroundColor: '#f7f7f7', padding: 5 }}>
      <Title comcode="PrefinInterest" level={5}></Title>
      <Form.Item
        noStyle
        shouldUpdate={shouldUpdateCompare('clientInvoiceSchedules')}
      >
        {({ getFieldValue }) => (
          <DataGrid
            columns={columns}
            dataSource={prefinInterest}
            rowKey="calid"
            scroll={{ x: 1200, y: 360 }}
            hideFilters
          />
        )}
      </Form.Item>
    </div>
  );
};

export default TabClientInvoicePrefinInterest;
